import { render } from "./AppFramesGrid.vue?vue&type=template&id=549060cd&scoped=true"
import script from "./AppFramesGrid.vue?vue&type=script&lang=js"
export * from "./AppFramesGrid.vue?vue&type=script&lang=js"

import "./AppFramesGrid.vue?vue&type=style&index=0&id=549060cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549060cd"]])

export default __exports__